import React, { useEffect, useState } from "react";
import UserGraph from "./UserGraph";
import UserReports from "./UserReports";
import { handleUserSubscriptions, handleUsers } from "../../axios";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";

const Dashboard = () => {
  const { token } = useSelector((state) => state.auth);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleGetUsers = async () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    try {
      const res = await handleUsers(config);

      if (res?.status === 200) {
        setUsers(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetUsers();
  }, []);

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const {
    data: subscriptions,
    isLoading: subscriptionsLoading,
    isSuccess: subscriptionsSuccess,
    isError,
  } = useQuery(["subscriptions"], () => handleUserSubscriptions(config));

  return (
    <div>
      <div>
        <p className="font-semibold antialiased tracking-normal text-[22px]">
          Dashboard
        </p>
      </div>
      <div className="mt-6">
        <UserGraph users={users} loading={loading} />
      </div>
      <div className="mt-6">
        <UserReports users={users} subscriptions={subscriptions?.data} />
      </div>
    </div>
  );
};

export default Dashboard;
